export const setPageTitle = (pageTitle: string): string => {
  return `${pageTitle} | Exam Hub`;
};
